import {db} from "@/services/db";
import firebase from 'firebase/app'
import 'firebase/firestore'
import FirebaseWrite from "@/services/database/firebaseWrite";
import TimeStamp from "@/services/timeStamp";

export class PassNrService {
    constructor(lvId, geschlecht) {
        this.lvId = lvId
        this.geschlecht = geschlecht
        this.docId = lvId + '_' + geschlecht
        this.neuePassNr = null;
        this.updateObject = {};
        // herren ab 1000, Frauen ab 6000
        // Leihspieler ab 4500, Damen ab 9500
    }

    async getPassNr(){
        return await this.readAndUpdateDoc()
    }

    readAndUpdateDoc(){
        const lvPassNrDocPath = db.collection("lvPassNr").doc(this.docId);
        return db.runTransaction(transaction => {
            // This code may get re-run multiple times if there are conflicts.
            return transaction.get(lvPassNrDocPath).then(doc => {
                this.setNewNumber(doc.data())
                transaction.update(lvPassNrDocPath, this.updateObject);
            });
        }).then(()=> { return {successful: true, data: this.lvId + this.neuePassNr}
        }).catch((err)=> { return {successful: false, data: err}});
    }

    setNewNumber(lvPassNrDoc){
        const freieNummern = Object.keys(lvPassNrDoc.freieNummern);
        if ( freieNummern.length === 0 ) {
            this.neuePassNr = lvPassNrDoc.letzteNr + 1
            this.updateObject = {letzteNr: this.neuePassNr}
        } else {
            this.neuePassNr = this.getFreieNummerIfDateFits(lvPassNrDoc, freieNummern)
            if ( this.neuePassNr !== lvPassNrDoc.letzteNr + 1 ) {
                this.updateObject = {['freieNummern.' + this.neuePassNr]: firebase.firestore.FieldValue.delete()}
            } else {
                this.updateObject = {letzteNr: this.neuePassNr}
            }
        }
    }
        getFreieNummerIfDateFits(lvPassNrDoc, freieNummern){
            const todayString = TimeStamp.getTodayString()
            const todayYear = todayString.substring(0,4)
            const newYear = parseInt(todayYear) - 3
            const targetDate = todayString.replace(todayYear, newYear)
            for ( let i = 0; i < freieNummern.length; i++ ) {
                const freieNr = freieNummern[i]
                const freieNrDatum = lvPassNrDoc.freieNummern[freieNr]
                if ( freieNrDatum <= targetDate ) return parseInt(freieNr)
            }
            return lvPassNrDoc.letzteNr + 1
        }

    addFreeNumber(freeNumber){
        FirebaseWrite.update('lvPassNr', this.docId, {['freieNummern.' + freeNumber]:
            TimeStamp.getTodayString()
        })
    }

// CONVERSION
    async createNewNrDoc(lvId, letzteNr, freieNummern){
        await FirebaseWrite.set('lvPassNr', lvId + '_' + this.geschlecht, {
            freieNummern: freieNummern,
            letzteNr: letzteNr,
            geschlecht: this.geschlecht,
        })
    }

}